var exports = {
  "Sn": "FooterVisual__7Mgd6g",
  "Ab": "FallbackImage__WVZcaG",
  "lB": "FullHeight__37LZQ1",
  "P": "StackedVisuals__aaQxE6",
  "lx": "HalfHeight__GSbmer",
  "o7": "FinalItem__ZtLbd2",
};

module.exports = exports;
